<ng-container>
    <div *ngIf="!isApiError">
        <xm-modal-close xmEscKey (escKeyPressed)="close()" (onClose)="close()"></xm-modal-close>
        <div class="image-primary">
            <xm-media-image [imageOptions]="imagePrimary" size="width"></xm-media-image>
        </div>
        <h1 mat-dialog-title>{{ pendingRemovalData.header }}</h1>
        <div class="flex-container">
            <div class="feature-content">
                <p class="description">{{ pendingRemovalData.subhead }}</p>
                <div class="feature-list" *ngFor="let feature of features">
                    <xm-media-image [imageOptions]="feature.imageOption" size="height" class="icons"></xm-media-image>
                    <div class="feature-details">
                        <cms-text class="feature-description" [originalText]="feature.description"></cms-text>
                    </div>
                </div>
            </div>
        </div>
        <p *ngIf="isSuccess" class="success-message">{{ pendingRemovalData.successDescription }}</p>
        <div class="button">
            <button *ngIf="!isSuccess" [promiseBtn]="submitPromise" class="xm-btn-primary-light promise-btn" (click)="submit()"><span>{{ pendingRemovalData.cancelRemovalCTA }}</span></button>
            <button *ngIf="isSuccess" class="xm-btn-primary-light" (click)="onDoneClick()"><span>{{ pendingRemovalData.doneCTA }}</span></button>
        </div>
    </div>
    <div *ngIf="isApiError">
        <xm-modal-close xmEscKey (escKeyPressed)="close()" (onClose)="close()"></xm-modal-close>
        <div class="image-primary">
            <xm-media-image [imageOptions]="imagePrimary" size="width"></xm-media-image>
        </div>
        <h1 mat-dialog-title>{{ pendingRemovalData.header }}</h1>
        <div class="flex-container">
            <div class="feature-content">
                <p class="failed-header">{{ pendingRemovalData.failedHeader }}</p>
                <div class="image-primary">
                <xm-media-image [imageOptions]="failureIcon" size="width"></xm-media-image>
                </div>
                <cms-text [originalText]="pendingRemovalData.failedDescription" class="failed-description"></cms-text>
            </div>
        </div>
    </div>
</ng-container>
